import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-download-info',
  imports: [],
  templateUrl: './download-info.html',
  styleUrl: './download-info.scss'
})
export class DownloadInfo {

  @Input() downloadLinks: { apple: string, google: string } | undefined = undefined;


  goTo(url: string) {
    window.open(url, '_blank');
  }

}
